// Sticky floating pill toggle. Shared by /growth (Marketing/Creative) and the
// pricing section (Marketing & creative / Workflow & automation).
export const SegmentedPillToggle = ({
  options,
  value,
  onChange,
  ariaLabel,
  idPrefix = "seg",
  controlsPrefix,
  testId,
  className = "",
}) => {
  const onKey = (e) => {
    if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
    e.preventDefault();
    const vals = options.map((o) => o.value);
    const i = vals.indexOf(value);
    const next = vals[(i + (e.key === "ArrowRight" ? 1 : vals.length - 1)) % vals.length];
    onChange(next);
    document.getElementById(`${idPrefix}-${next}`)?.focus();
  };

  return (
    <div
      role="tablist"
      aria-label={ariaLabel}
      style={{ backgroundColor: "color-mix(in srgb, var(--charcoal) 92%, transparent)" }}
      className={`inline-flex rounded-full border border-white/15 p-1 shadow-[0_12px_40px_-12px_rgba(0,0,0,0.5)] backdrop-blur-md ${className}`}
      data-testid={testId}
    >
      {options.map((o) => {
        const selected = value === o.value;
        return (
          <button
            key={o.value}
            role="tab"
            id={`${idPrefix}-${o.value}`}
            aria-selected={selected}
            aria-controls={controlsPrefix ? `${controlsPrefix}-${o.value}` : undefined}
            tabIndex={selected ? 0 : -1}
            onClick={() => onChange(o.value)}
            onKeyDown={onKey}
            data-testid={o.testId || `${testId}-${o.value}`}
            className={`rounded-full px-7 py-3.5 text-sm font-semibold transition-colors duration-300 ${
              selected ? "bg-[var(--mint)] text-[var(--charcoal)]" : "text-white/70 hover:text-white"
            }`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
};
